import React from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import './index.css'
import App from './App'
import { APPMODE } from './core.js'

const container = document.getElementById('root')

const useStrictMode = !(APPMODE == 'prod' || APPMODE == 'dev' || APPMODE == 'pre')

const app = useStrictMode
  ? (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  )
  : <App />

// Datengetriebene Routen: Inhalt hängt von einem Strapi-Fetch ab. Der vorgerenderte Snapshot
// dient hier nur den Crawlern; im Client wird frisch gerendert (Live-Daten, kein Hydration-Mismatch).
const DYNAMIC_PREFIXES = ['/news', '/projects', '/linktree']
const path = window.location.pathname
const isDynamicRoute =
  path.startsWith('/l/') ||
  DYNAMIC_PREFIXES.some((p) => path === p || path.startsWith(p + '/'))

// Statische Seiten: wurde HTML vorgerendert -> hydrieren (kein Flackern, schneller First Paint).
if (!isDynamicRoute && container.hasChildNodes()) {
  hydrateRoot(container, app)
} else {
  container.innerHTML = ''
  createRoot(container).render(app)
}
